import React from 'react';
import './styles.scss';
import { FaChevronLeft } from 'react-icons/fa6';
import headerImage from "./fully_subscribed_svg.svg";
import Button from '../Button';
import { useNavigate } from 'react-router-dom';

function FullySubscribedPopup({toggleInvest }){
    const navigate = useNavigate();

    const handleNotifyClick = () => {
        if (toggleInvest) {
            toggleInvest();
        }
        navigate('/notifywhenlive');
    };

    return (
        <div className="fully-subscribed-popup">
            <FaChevronLeft style={{color: 'white', position: 'absolute', top: '1.5%', left: '5px', fontSize: '20px', strokeWidth: '40'}} onClick={toggleInvest}/>
            <div className="fully-subscribed-popup-container">
                <div className="fully-subscribed-popup-header">
                    <img src={headerImage} alt="header"/>
                </div>
                <div className="fully-subscribed-popup-content">
                    <p className="fullySubscribedText">Fully Subscribed!</p>
                    <div className="fully-subscribed-popup-content-copy">
                        <p className="fully-subscribed-popup-content-copy-text">
                            Our current AEX portfolio has been fully purchased, and no new investments can be made at this time.
                        </p>
                        <p className="fully-subscribed-popup-content-copy-text">
                            Thank you for the overwhelming support. New high-growth opportunities are launching soon — and we can&apos;t wait to share them with you.
                        </p>
                    </div>
                    <Button className="notify-button" onClick={handleNotifyClick}>Notify Me When Live</Button>
                </div>
                
            </div>
        </div>
    )
}

export default FullySubscribedPopup;
